import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

export function formatWeekRangeLabel(after: string, before?: string | null): string | null {
    const weekStart = moment(after, DATE_FORMAT, true);
    if (!weekStart.isValid()) return null;

    const weekEnd = before
        ? moment(before, DATE_FORMAT, true)
        : weekStart.clone().endOf('isoWeek');
    if (!weekEnd.isValid()) return null;

    return `${weekStart.format('D MMM')}–${weekEnd.format('D MMM YYYY')}`;
}

export function mapDateParamsForApi(params: URLSearchParams): URLSearchParams {
    const result = new URLSearchParams(params);
    const after = result.get('after');
    const before = result.get('before');
    result.delete('after');
    result.delete('before');
    if (after) result.set('bookings_after', after);
    if (before) result.set('bookings_before', before);
    return result;
}

/**
 * Returns true when the given Monday falls within the allowed recency window:
 * the current week or up to 2 weeks in the past. Future weeks are not extendable.
 */
export function isWithinRecencyWindow(bookingsAfter: string): boolean {
    const sourceMonday = moment(bookingsAfter, DATE_FORMAT, true);
    if (!sourceMonday.isValid()) return false;
    const thisWeekMonday = moment().startOf('isoWeek');
    const earliestAllowed = thisWeekMonday.clone().subtract(2, 'weeks');
    return !sourceMonday.isBefore(earliestAllowed) && !sourceMonday.isAfter(thisWeekMonday);
}
